<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="my-5">
		<PaymentMethodsView
			ref="paymentMethodsView"
			:hideTitle="true"/>
<!--		<ProgramBillingPanel-->
<!--			style="width: 400px;"-->
<!--			:hideTitle="true"-->
<!--			:data="billingData"-->
<!--			:programItem="programItem"-->
<!--			:disableInvoices="true"-->
<!--			modalSize="70%"-->
<!--			:modal="false"-->
<!--			:analytics-props="analyticsPropsMethod()"-->
<!--			@change="onBillingDataChanged"-->
<!--			v-bind="$attrs"/>-->

	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";
import CoachingSessionsPanel from "@/core/modules/coach/Coaching/Panels/CoachingSessionsPanel/CoachingSessionsPanel.vue";
import ProgramBillingPanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/ProgramBillingPanel.vue";
import BillingData from "@shared/Billing/BillingData";
import BillingMain from "@/core/modules/coach/Billing/BillingMain.vue";
import PaymentMethodsView from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodsView.vue";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";

export default {
	name: "SetupBillingMethodsStep",
	components: {PaymentMethodsView},
	extends: BaseWizardStep,

	data() {
		return {
			sessionType: null,
			billingData: new BillingData()
		}
	},

	methods:{

		stepId(){
			return "setup_billing_methods_step"
		},

		isStepRequired(){
			return false
		},

		async loadData(){
			console.log("SetupSessionsStep.loadData this.programItem = ", this.programItem)
			if (this.programItem.sessionTypeId) {
				this.sessionType = await this.$dataManager.apiGetEventType({sessionTypeId: this.programItem.sessionTypeId, coachId: this.getCoachId()})
			}
		},

		async validateStep(){
			return this.confirmIfNoMethods()
		},

		async onNextClicked(){
		},

		async onSkipClicked(){
			return this.confirmIfNoMethods()
		},


		confirmIfNoMethods(){
			let hasIntegration = this.$refs.paymentMethodsView.hasPaymentIntegrations()
			if(hasIntegration){
				return true
			}
			return yesNoDialog({
				title: "Proceed without a billing method?",
				message: "If you skip this step, you won't be able to automatically collect payments from your clients. <br/><br/>You will still be able to add billing methods later on.",
				yesButton: "Skip"
			})
		},

		stepDescription(){
			let description = ""
			this.sessionType ? description += this.sessionType.displayName + "\n" : ""
			description += this.programItem.sessionsLimit + " sessions"
			return description
		},

		onBillingDataChanged(){

		}

	},

	computed:{
		programItem(){
			return this.getWizardDataByStepId("create_program_step")
		},
		agreementRow(){
			let agreementRow
			this.programItem.findStep(step => step.isTypeContract(), step => agreementRow = step)
			if(!agreementRow){
				agreementRow = new ContractProgramStep()
				let section = this.programItem.programSteps[0]
				section.addProgramStep(agreementRow)
			}
			return agreementRow
		},

		drawerSize(){
			let res = window.outerWidth - 400
			res = res + "px"
			console.log("window.outerWidth = ", res)
			return res
		}
	}
}
</script>

<style lang="scss">

</style>
